import { createAction, props } from '@ngrx/store';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { IAreaDate } from 'src/app/modules/report-components/models/IAreaDate';
import { AnonymousUser } from 'src/app/modules/report-components/models/AnonymousUser';

//
// COMMANDS [verbNoun]
//

export const loadReport = createAction(`[Anonymous Report Page] Load Report`);

//
// EVENTS [nounVerb]
//

export const reportLoadError = createAction(`[Anonymous Report Page] Report Load Error`, props<{ error: string }>());

//
// DOCUMENTS [setNoun]
//

export const setCurrentReport = createAction(
  `[Anonymous Report Page] Set Current Report`,
  props<{
    report: IGlimpseReport;
    cache: boolean;
    user: AnonymousUser;
  }>()
);
